// Live wallet chip — shows free-trial countdown, balance, or plan credits.
// Click to open the wallet pop-out (top-up, plans, auto-refill, history).
import { useEffect, useState } from "react";
import { Wallet } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useWallet } from "@/hooks/useWallet";
import WalletSheet from "@/components/wallet/WalletSheet";
import SubscriptionNudgeDialog from "@/components/wallet/SubscriptionNudgeDialog";

export default function WalletChip() {
  const { user } = useAuth();
  const { wallet, subscription, isTrialing } = useWallet();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("open-wallet", onOpen);
    return () => window.removeEventListener("open-wallet", onOpen);
  }, []);
  if (!user) return null;

  let label = "$0.00";
  if (isTrialing) {
    const m = Math.floor((wallet?.free_seconds_remaining ?? 0) / 60);
    label = `${m}m free`;
  } else if (subscription?.status === "active") {
    label = `$${(((subscription.monthly_credits_remaining_cents ?? 0) + (wallet?.balance_cents ?? 0)) / 100).toFixed(2)}`;
  } else {
    label = `$${((wallet?.balance_cents ?? 0) / 100).toFixed(2)}`;
  }

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="h-9 px-3 inline-flex items-center gap-1.5 rounded-full border border-border bg-card/40 hover:border-primary/50 text-[11px] font-mono"
        title="Open wallet"
      >
        <Wallet className="w-3.5 h-3.5 text-primary" />
        <span className="text-foreground/90">{label}</span>
      </button>
      <WalletSheet open={open} onOpenChange={setOpen} />
      <SubscriptionNudgeDialog />
    </>
  );
}